module.exports = __webpack_public_path__ + "img/bn_contact.e489dcae.png";